/**
 * A count as the prototype draws it (`<small>` in rows and headings), content-sized and never clipped
 * (fix 2): compact from 10,000 with the exact value as tooltip and accessible name.
 */

import type { HTMLAttributes } from 'react';
import { formatCount, formatExact, isCompacted } from './format.js';

export interface CountProps extends HTMLAttributes<HTMLElement> {
  value: number;
  /** Element to render (default `small`). */
  as?: 'small' | 'span' | 'b';
  /** Words for the accessible name, e.g. "messages". */
  noun?: string;
}

export function Count({ value, as = 'small', noun, className, ...rest }: CountProps) {
  const Tag = as;
  const compact = isCompacted(value);
  const label = `${formatExact(value)}${noun ? ` ${noun}` : ''}`;
  return (
    <Tag
      className={className ? `count ${className}` : 'count'}
      title={compact ? formatExact(value) : undefined}
      aria-label={compact || noun ? label : undefined}
      data-count={value}
      {...rest}
    >
      {formatCount(value)}
    </Tag>
  );
}
